import request from "@/util/http";
import qs from "qs"; // 获取用户权限

export function getPersonTree(query) {
  return request({
    url: "/admin/dept/chargeManDeptTree",
    method: "get",
    params: query
  });
} // 分页查询负责人列表

export function getPersonList(obj) {
  return request({
    url: "/admin/chargeman/page",
    method: "get",
    params: obj
  });
} // 查询已添加负责人

export function getAllPersonList(obj) {
  return request({
    url: "/admin/chargeman/all",
    method: "get",
    params: obj
  });
} // 添加负责人

export function addPerson(obj) {
  return request({
    url: "/admin/chargeman",
    method: "post",
    data: qs.stringify(obj)
  });
} //删除负责人

export function deletePerson(obj) {
  return request({
    url: "/admin/chargeman/remove/?" + qs.stringify(obj),
    method: "get" // params : qs.stringify(obj)

  });
} //学科负责人

export function getXueKePerson(obj) {
  return request({
    url: "/admin/subject/page/?" + qs.stringify(obj),
    method: "get" // params : qs.stringify(obj)

  });
} //机构新负责人列表

export function getDeptChargeMan(obj) {
  return request({
    url: "/admin/chargeman/dept/page",
    method: "get",
    params: obj
  });
} //机构新负责人列表

export function saveChargeMan(obj) {
  return request({
    url: "/admin/chargeman",
    method: "post",
    data: qs.stringify(obj)
  });
} //机构新负责人列表

export function getAllChargeMan(obj) {
  return request({
    url: "/admin/chargeman/all/?id=" + obj.id + "&type=" + obj.type,
    method: "get" // params : qs.stringify(obj)

  });
} //专业新负责人列表

export function getMajorsMan(obj) {
  return request({
    url: "/admin/chargeman/majors/page",
    method: "get",
    params: obj
  });
} //班级新负责人列表

export function getClassMan(obj) {
  return request({
    url: "/admin/chargeman/classes/page",
    method: "get",
    params: obj
  });
} //学科新负责人列表

export function getSubjectMan(obj) {
  return request({
    url: "/admin/chargeman/subject/page",
    method: "get",
    params: obj
  });
} //课程新负责人列表

export function getCourseMan(obj) {
  return request({
    url: "/admin/chargeman/course/page",
    method: "get",
    params: obj
  });
} // /admin/chargeman/page	get	{page：，id : 对应的id， type: 类型, name: }